import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PolaznikUcionicaService {

  headers = new Headers();

  constructor(private _http: Http) { }

  videoZapisi(user: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_videozapise_polaznika_za_ucionicu/', user)
    .map(res => res.json());
  }

  dokumenti(user: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_pisanematerijale_polaznika_za_ucionicu/', user)
    .map(res => res.json());
  }

  dohvatiModuleNew(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_modulnew_ucionica', a)
    .map(res => res.json());
  }

  urediEdukacije(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'generiranje_datuma_edukacije', a)
    .map(res => res.json());
  }

  uredijednuEdukaciju(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'kreiranje_rasporeda_edukacije', a)    
    .map(res => res.json());
  }

  dohvatiPrisutnostPolaznikUcionica(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_prisutnost_polaznika_ucionica', a)
    .map(res => res.json());
  }

  updateBrojaPregleda(user: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'broj_pregleda_pojedinog_videozapisa/', user)
    .map(res => res.json());
  }

  dohvati_ishode_nastavnih_jedinica_za_polaznika(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_ishode_nastavnih_jedinica_za_polaznika', a)
    .map(res => res.json());
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/polaznik-ucionica/polaznik-ucionica.service.ts